<div class="modal-body">
  <div class="modal-text-wrapper-info">
    <p class="title">{{title}}</p>
    <p class="body">{{information}}</p>
    <p class="cbmRefNo" style="color: #84BD00">{{cbmRefNo}}</p>
  </div>
  
  <button type="button" class="modal-btn-primary" (click)="activeModal.close('Close click')">{{positiveButton}}</button>
</div>